import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CompanySettingsModel }            from '../companies/models/company.settings';
import { CustomerPortalService }           from './customer-portal.service';
import { CustomerPortalSettingsComponent } from './customer-portal.settings.component';

export const CustomerPortalStates : Array<NgHybridStateDeclaration> = [
  {
    component: CustomerPortalSettingsComponent,
    name     : 'app.customer-portal-settings',
    resolve  : [
      {
        deps     : [ CustomerPortalService ],
        resolveFn: ( customerPortalService : CustomerPortalService ) : Promise<CompanySettingsModel> => customerPortalService.getSettings(),
        token    : 'settings'
      }
    ],
    url: '/customer-portal-settings'
  }
];
